import type { ImageAnalyses } from '@/@types/latestImagesV2';
import { ImageThumbnail } from '@/modules/claims/cleanClaims/images/ImageThumbnail';
import { useLocalizedFormatDate } from '@/modules/claims/freeClaims/state';
import { useDevtoolsShortcut } from '@/utils/hooks/useDevtoolsShortcut';

type SingleImageItemProps = {
  image: ImageAnalyses;
  enabledFindings?: string[];
  includedTeethIds?: string[];
  title?: string;
  height?: number;
  width?: number;
};

export const SingleImageItem = ({
  title,
  image,
  enabledFindings = [],
  includedTeethIds,
  height = 250,
  width = 250,
}: SingleImageItemProps) => {
  const { showDevtools } = useDevtoolsShortcut();
  const formatDate = useLocalizedFormatDate();

  const formattedDate = image.imageAcquiredAt
    ? formatDate(image.imageAcquiredAt)
    : '';

  return (
    <div
      data-cy={`image-item-${image.imageId}`}
      className="vai-flex vai-flex-col vai-items-center"
    >
      <span className="vai-text-slate-500 vai-text-xs vai-tracking-wide vai-uppercase vai-mb-1 vai-text-center vai-w-full">
        {title}
        {showDevtools && <p>{image.imageId}</p>}
      </span>
      <div className="vai-flex vai-justify-center vai-items-center vai-w-full">
        <ImageThumbnail
          image={image}
          height={height}
          width={width}
          enabledFindings={enabledFindings}
          includedTeethIds={includedTeethIds}
          showIncipientCariesRed
        />
      </div>
      {formattedDate && (
        <span className="vai-text-slate-500 vai-text-xs vai-mt-1">
          {formattedDate}
        </span>
      )}
    </div>
  );
};
